import { IconCollection } from "components/Icon/IconCollection";
import { ResourceConfig } from "config/config";
import { exportActionSignature } from "containers/Resources/components/CommonActions/CommonActions";
import { logsTab, logsTabKey } from "containers/Resources/screens/ResourcesSingle/constants";
import resource from "./resource";

const resourceName = "organization";

const config: ResourceConfig = {
    label: "Organization",
    icon: IconCollection.domain,
    resourceName,
    resourceClass: "resource",
    ignoreIsReadonly: true,
    isBulkDeleteForbidden: true,
    defaultActiveTab: logsTabKey,
    layout: [
        { partial: "pageHeaderForm" },
        { partial: "form" },
        { partial: "tabs", config: { tabs: [logsTab.tab], content: [logsTab.content] } },
    ],
    actions: {
        shown: [],
        hidden: [exportActionSignature],
    },
    graphql: {
        resource: resourceName,
        resourceBody: `
            ${resource.graphql.resourceBody}
            primary_contact
            active
            address_line_1
            address_line_2
            city
            region
            zip
            country
            vat_number
            payment_type
            is_trial_account
            issued_to
            issued_at
            expires_at
            ssp_enabled
        `,
        resourceBodyListing: `
            ${resource.graphql.resourceBody}
        `,
        updateVariables: `
            ${resource.graphql.updateVariables(resourceName)}
            $primary_contact: String,
            $address_line_1: String,
            $address_line_2: String,
            $city: String,
            $region: String,
            $zip: String,
            $country: String,
            $vat_number: String,
        `,
        updateQuery: `
            ${resource.graphql.updateQuery(resourceName)}
            primary_contact: $primary_contact,
            address_line_1: $address_line_1,
            address_line_2: $address_line_2,
            city: $city,
            region: $region,
            zip: $zip,
            country: $country,
            vat_number: $vat_number
        `,
    },
    form: [
        {
            name: "primary_contact",
            component: "text",
            fieldProps: {
                label: "Primary contact",
            },
        },
        {
            name: "active",
            component: "value",
            fieldProps: {
                label: "Active",
            },
        },
        {
            name: "address_line_1",
            component: "text",
            fieldProps: {
                label: "Address line 1",
            },
        },
        {
            name: "address_line_2",
            component: "text",
            fieldProps: {
                label: "Address line 2",
            },
        },
        {
            name: "city",
            component: "text",
            fieldProps: {
                label: "City",
            },
        },
        {
            name: "region",
            component: "text",
            fieldProps: {
                label: "Region",
            },
        },
        {
            name: "zip",
            component: "text",
            fieldProps: {
                label: "Zip code",
            },
        },
        {
            name: "country",
            component: "text",
            fieldProps: {
                label: "Country",
            },
        },
        {
            name: "vat_number",
            component: "text",
            fieldProps: {
                label: "VAT number",
            },
        },
        {
            name: "payment_type",
            component: "value",
            fieldProps: {
                label: "Payment type",
            },
        },
        {
            name: "is_trial_account",
            component: "value",
            fieldProps: {
                label: "Is trial account",
            },
        },
        {
            name: "issued_to",
            component: "value",
            fieldProps: {
                label: "License issued to",
            },
        },
        {
            name: "issued_at",
            component: "dateTime",
            fieldProps: {
                label: "License issued at",
                isReadOnly: true,
            },
        },
        {
            name: "expires_at",
            component: "dateTime",
            fieldProps: {
                label: "License expires at",
                isReadOnly: true,
            },
        },
        {
            name: "ssp_enabled",
            component: "value",
            fieldProps: {
                label: "Self-service portal enabled",
            },
        },
    ],
    hideCreateNew: true,
};
export default config;
